<template>
  <!-- Features Section Start -->
  <section id="features" class="section-padding">
    <div class="container">
      <div class="section-header text-center">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">فهرست رساله های دکتری ایران شناسی</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
          <div class="content-left">
            <div class="box-item wow fadeInLeft" v-for="(doctor , id) in doctors.slice(0,4)" :key="id" :data-wow-delay="doctor.delay" >
                <span class="icon">
                  <img :src="'/img/Doctors/'+ doctor.img" :alt="doctor.student" class="img-fluid  mrBorder">
<!--                  <i class="lni-rocket"></i>-->
                </span>
              <div class="text">
                <h4><small class="text-muted">دانشجو: </small>{{doctor.student}}</h4>
                <p><small class="text-muted"> استاد راهنما: </small>{{doctor.Supervisors}}</p>
<!--                <p><small class="text-muted"> استاد مشاور: </small>{{doctor.advisor}}</p>-->
                <p><small class="text-muted">تاریخ دفاع: </small>{{doctor.date}}</p>
                <p><small class="text-muted">عنوان رساله: </small>{{doctor.title}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 p-5">
          <div class="show-box wow fadeInUp" data-wow-delay="0.3s">
            <img src="/img/Doctors/doctors.png" alt="" class="img-fluid">
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
<!--          <div class="content-right">-->
<!--            <div class="box-item wow fadeInRight" data-wow-delay="0.3s">-->
<!--                <span class="icon">-->
<!--                  <i class="lni-leaf"></i>-->
<!--                </span>-->
<!--              <div class="text">-->
<!--                <h4>Modern Design</h4>-->
<!--                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="box-item wow fadeInRight" data-wow-delay="0.6s">-->
<!--                <span class="icon">-->
<!--                  <i class="lni-layers"></i>-->
<!--                </span>-->
<!--              <div class="text">-->
<!--                <h4>Multi-purpose Template</h4>-->
<!--                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="box-item wow fadeInRight" data-wow-delay="0.9s">-->
<!--                <span class="icon">-->
<!--                  <i class="lni-leaf"></i>-->
<!--                </span>-->
<!--              <div class="text">-->
<!--                <h4>Working Contact Form</h4>-->
<!--                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="content-left">
            <div class="box-item wow fadeInLeft" v-for="(doctor , id) in doctors.slice(4,8)" :key="id" :data-wow-delay="doctor.delay" >
                <span class="icon">
                  <img :src="'/img/Doctors/'+ doctor.img" :alt="doctor.student" class="img-fluid  mrBorder">
                  <!--                  <i class="lni-rocket"></i>-->
                </span>
              <div class="text">
                <h4><small class="text-muted">دانشجو: </small>{{doctor.student}}</h4>
                <p><small class="text-muted"> استاد راهنما: </small>{{doctor.Supervisors}}</p>
                <!--                <p><small class="text-muted"> استاد مشاور: </small>{{doctor.advisor}}</p>-->
                <p><small class="text-muted">تاریخ دفاع: </small>{{doctor.date}}</p>
                <p><small class="text-muted">عنوان رساله: </small>{{doctor.title}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Features Section End -->

</template>

<script>
import {doctorsThesis} from '@/Data/thesisDotorData'
export default {
  name: "ListThesisDoctors",
  data(){
    return{
    doctors:  doctorsThesis,
    }
  },
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/color";
.mrBorder {
  border-radius: 25px;
  border: 3px solid $green;
}
</style>